import React from 'react';

import IconButton from '../../../../../components/icon-button/icon-button';
import { ES_IT_MEDIA } from '../../constants';
import PresentationalLink from '../presentation-link/presentation-link';
import './social-icons.scss';

interface Props {
  lang: string;
}

const SocialIcons: React.FC<Props> = ({ lang }) => {
  const { instagram, youtube, facebook, twitter } = ES_IT_MEDIA[lang];

  return (
    <div className="rc-growth-section__icon-buttons">
      <div className="rc-growth-section__icon-buttons_wrapper">
        <IconButton name="instagram" href={instagram.link} height={40} />
        <PresentationalLink href={instagram.link} label={instagram.label} />
      </div>
      <div className="rc-growth-section__icon-buttons_wrapper">
        <IconButton name="youtube" href={youtube.link} height={40} />
        <PresentationalLink href={youtube.link} label={youtube.label} />
      </div>
      <div className="rc-growth-section__icon-buttons_wrapper">
        <IconButton name="facebook" href={facebook.link} height={40} />
        <PresentationalLink href={facebook.link} label={facebook.label} />
      </div>
      <div className="rc-growth-section__icon-buttons_wrapper">
        <IconButton name="twitter" href={twitter.link} height={40} />
        <PresentationalLink href={twitter.link} label={twitter.label} />
      </div>
    </div>
  );
};

export default SocialIcons;
